import { useUser } from "hooks/use-user";
import CCAOpenTicketsList from "./callCenterAgentTickets/open-tickets-list";
import DispatcherOpenTicketsList from "./dispatcherTickets/open-tickets-list";
import { isCallCenterAgent } from "./utils";

export default function OpenTicketsList() {
  const user = useUser();

  const isCCA = isCallCenterAgent(user);
  if (isCCA) {
    return <CCAOpenTicketsList />;
  }

  return <DispatcherOpenTicketsList />;
}
